export default "__VITE_ASSET__Ddh8bprJ__"